<template>
  <div>
    <div class="mb-4">
      <aha-breadcrumb :hasMultipleLevels="hasMultipleLevels">
        <aha-breadcrumb-item
          :text="secondLevel"
          :clickable="isSecondLevelClickable"
          @click="isSecondLevelClickable ? $emit('clickSecondLevel') : false"
        />

        <!-- nLevelArray is server's response, whilst we define 1st and 2nd level -->
        <span v-for="(objItem, index) in nLevelArray" :key="index" class="multiple-levels__wrapper">
          <aha-breadcrumb-item
            :text="objItem.folderName"
            v-if="objItem && objItem.folderName && objItem.folderName.length"
            :clickable="index < nLevelArray.length - 1"
            @click="(index < nLevelArray.length - 1) ? $emit('clickNLevel', objItem.folderId) : false"
            isMultipleLeveledItem
          />
        </span>
      </aha-breadcrumb>

      <!-- Title -->
      <div class="mt-2 text-lg font-bold">
        <h2 class="truncate">
          {{ breadcrumbsTitle || defaultTitle }}
        </h2>
      </div>
    </div>
    <div class="mb-4 border-b border-secondary-20" v-if="!noBorder" />
  </div>
</template>

<script>
export default {
  props: {
    secondLevel: {
      type: String,
      default: '',
    },
    nLevelArray: {
      type: Array,
      default: () => [{}],
    },
    isSecondLevelClickable: {
      type: Boolean,
      default: false,
    },
    defaultTitle: {
      type: String,
      default: '',
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    hasMultipleLevels: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    breadcrumbsTitle() {
      return this.nLevelArray && this.nLevelArray.length &&
        this.nLevelArray[this.nLevelArray.length - 1] && this.nLevelArray[this.nLevelArray.length - 1].folderName
    },
  },
}
</script>

<style lang="scss" scoped>
.multiple-levels__wrapper:last-child {
  &::v-deep {
    .breadcrumb__item--divider.is-multiple-leveled-item {
      @apply hidden;
    }
  }
}
</style>
